<script setup>
import { ref, watch } from "vue";
import DataService from "../../services/data.service";
import ModalUserUpdate from "./ModalUserUpdate.vue";
import EventBus from "../../common/EventBus";
import bootstrap from "bootstrap/dist/js/bootstrap";
import DataTable from "datatables.net-vue3";
import DataTableLib from "datatables.net-bs5";
import ButtonHtml5 from "datatables.net-buttons/js/buttons.html5";
import print from "datatables.net-buttons/js/buttons.print";
import pdfMake from "pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import "datatables.net-responsive-bs5";
import JSZip from "jszip";

window.JSZip = JSZip;
pdfMake.vfs = pdfFonts.pdfMake.vfs;

DataTable.use(DataTableLib);
DataTable.use(pdfMake);
DataTable.use(ButtonHtml5);
DataTable.use(print);

const users = ref([]);
const UserSelect = ref({});
const isDataLoaded = ref(false); // Bandera para controlar la carga de datos
const isEditing = ref(false);

const props = defineProps({
  institutionId: Number, // Define el tipo de dato esperado
});

const columns = [
  { data: "documento" },
  {
    data: "name",
    // eslint-disable-next-line no-unused-vars
    render: function (data, type, row, meta) {
      if (row && row.name && row.apellido) {
        return `${row.name} ${row.apellido}`;
      }
      return ""; // Si no se puede acceder a 'name' o 'apellido', devuelve una cadena vacía.
    },
  },
  { data: "email" },
  { data: "telefono" },
  { data: "instituciones_nombres" },
  { data: "licencias_nombres" },
  { data: "rol_name" },
  { data: "status" },
  {
    data: null,
    render: "#action",
    title: "Action",
  },
];

const button = [
  {
    title: "Reporte de Usuarios con Acceso",
    extend: "excelHtml5",
    text: '<i class="fa-regular fa-file-excel"></i> Excel',
    className: "btn btn-success btn-sm",
    exportOptions: {
      columns: ":not(:last-child)",
    },
  },
  {
    title: "Reporte de Usuarios con Acceso",
    extend: "pdfHtml5",
    text: '<i class="fa-regular fa-file-pdf"></i> PDF',
    className: "btn btn-success btn-sm",
    exportOptions: {
      columns: ":not(:last-child)",
    },
  },
  {
    title: "Reporte de Usuarios con Acceso",
    extend: "print",
    text: '<i class="fa-solid fa-print"></i> Imprimir',
    className: "btn btn-success btn-sm",
    exportOptions: {
      columns: ":not(:last-child)",
    },
  },
  {
    title: "Reporte de Usuarios con Acceso",
    extend: "copy",
    text: '<i class="fa-regular fa-file-lines"></i> CVS',
    className: "btn btn-success btn-sm",
    exportOptions: {
      columns: ":not(:last-child)",
    },
  },
];

// Función para obtener los datos según la institución seleccionada
const fetchData = () => {
  if (!props.institutionId) return;

  DataService.getUserAccess(props.institutionId)
    .then(
      (response) => {
      users.value = response.data;
      isDataLoaded.value = true; // Marcar los datos como cargados
    },
      (error) => {
        const content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();

        if (error.response && error.response.status === 403) {
          EventBus.dispatch("logout");
        }

        return content;
      }
    )
    .catch((error) => {
      console.error("Error obteniendo datos:", error);

    });
};

// Llamar a la API cuando el componente se monta
watch(
  () => props.institutionId,
  () => {
    isDataLoaded.value = false;
    fetchData();
  },
  { immediate: true }
);

const showPopup = (userData = null) => {
  UserSelect.value = userData ? { ...userData } : null;
  isEditing.value = !!userData;

  const myModal = new bootstrap.Modal(document.getElementById("UserModal"));
  myModal.show();
};

const handleEmpleadoActualizado = () => {
  fetchData();
};

const getPersonalName = (rowData) => {
  return rowData.personal && rowData.personal.name
    ? rowData.personal.name
    : "No data";
};
</script>
<style>
@import "datatables.net-bs5";

.dt-type-numeric {
  text-align: center !important;
}
.dt-paging {
  display: flex;
  float: right;
}

div.dt-container div.dt-search {
    text-align: right;
    position: absolute;
    right: 1vh;
    top: 9vh;
    z-index: 10;
}

</style>
<template>
  <div class="card">
    <div
      class="card-header px-1 d-flex justify-content-between align-items-center"
    >
      <h6 class="mb-0">Tabla de Usuarios con Acceso</h6>
      <button
        class="btn btn-sm pb-0 mb-0"
        @click="showPopup()"
      >
        Crear
      </button>
    </div>
    <div class="card-body px-1 pt-0 pb-2">
      <div v-if="isDataLoaded">
        <!-- Solo muestra la tabla si los datos están cargados -->
        <div class="table-responsive">
          <DataTable
            :key="props.institutionId"
            class="table table-sm"
            :data="users"
            :columns="columns"
            :options="{
              responsive: false,
              autoWidth: true,
              dom: 'Bfrtip',
              order: [],
              language: {
                search: 'Buscar',
                ZeroRecords: 'No hay registros',
                info: 'Mostrando _START_ a _END_ de _TOTAL_ registros',
                infoFiltered: '(Filtrados de _MAX_ registros.)',
                paginate: {
                  first: '<<',
                  previous: '<',
                  next: '>',
                  last: '>>',
                },
              },
              buttons: button,
            }"
          >
            <thead>
              <tr>
                <th>DNI</th>
                <th>Personal</th>
                <th>Email</th>
                <th>Contacto</th>
                <th>Resp. Personal</th>
                <th>Contratado</th>
                <th>Rol Asignado</th>
                <th>Estado</th>
                <th>Acción</th>
              </tr>
            </thead>
            <template #action="props">
              <button
                class="btn btn-sm pb-0 mb-0"
                :text="`Col 1: ${getPersonalName(props.rowData)}`"
                @click="showPopup(props.rowData)"
              >
                Editar
              </button>
            </template>
          </DataTable>
        </div>
      </div>
      <div v-else>
        <p>Cargando datos...</p>
      </div>
    </div>
    <ModalUserUpdate
      :initialData="UserSelect || {}"
      :isEditing="isEditing"
      @empleadoActualizado="handleEmpleadoActualizado"
    />
  </div>
</template>
